export { default } from "@/features/auth/screens/send-invite";
